var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-sales"),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { attrs: { id: "mainContainer" } }, [
        _c("div", { attrs: { id: "promoDescLabelContainer" } }, [
          _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "20px",
                width: "485px",
                "background-color": "#ffffff"
              }
            },
            [
              _c("span", { staticClass: "tituloSeccion" }, [
                _vm._v("Promociones")
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "verTodos",
                  on: { click: _vm.btnVerPromociones }
                },
                [_vm._v("Ver Todas")]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "20px",
                "background-color": "#ffffff"
              }
            },
            [
              _c("span", { staticClass: "tituloSeccion" }, [
                _vm._v("Descuentos")
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "verTodos",
                  on: { click: _vm.btnVerDescuentos }
                },
                [_vm._v("Ver Todos")]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "promoDescContainer" } }, [
          _c(
            "div",
            { attrs: { id: "promoContainer" } },
            _vm._l(_vm.itemsPromo, function(item) {
              return _c("item-promocion", { attrs: { item: item } })
            })
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              attrs: { id: "descContainer" },
              on: { click: _vm.btnVerDescuentos }
            },
            _vm._l(_vm.itemsDescuento, function(item) {
              return _c("item-descuento", { attrs: { item: item } })
            })
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { "margin-bottom": "20px", "margin-top": "20px" } },
          [
            _c(
              "span",
              { staticClass: "tituloSeccion", attrs: { id: "labelEstado" } },
              [_vm._v("Estado de Pedidos")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "verTodos",
                on: { click: _vm.btnVerEstadoPedidos }
              },
              [_vm._v("Ver Todos")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { id: "pedidoContainer" } },
          [
            _c(
              "div",
              {
                staticClass: "oblea-NuevoPedido",
                on: { click: _vm.btnNuevoPedido }
              },
              [
                _c("img", {
                  staticStyle: { width: "30px", height: "30px" },
                  attrs: { id: "icon-add", src: "/dist/icon-add.png" }
                }),
                _vm._v(" "),
                _c("p", { attrs: { id: "label-realizarPedido" } }, [
                  _vm._v("Nuevo Pedido")
                ])
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.itemsPedido, function(item) {
              return _c("item-pedido-home", { attrs: { item: item } })
            })
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "headerImageContainer" } }, [
      _c("img", {
        staticStyle: { height: "180px" },
        attrs: { id: "headerImage", src: "/dist/logo-header.png" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3dd6f9e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dd6f9e4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/home/home.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3dd6f9e4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/home/home.vue
// module chunks = 0